// extracted by mini-css-extract-plugin
export default {"footer-body":"footerbody_footer-body__m1CQM"};